export var SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
export var DEFAULT_APP_VERSION = '0.0.0';